export { default } from '@erikdakoda/ui/components/KeyShortcut';
export type {
  KeyShortcutProps,
  ModifierKeys,
  SpecialKeys,
} from '@erikdakoda/ui/components/KeyShortcut';
